import React, { useState } from "react";
import { useSelector } from "react-redux";
import { reviewAssistedFlowInfo, reviewResultsSelector, travellerDetailsSelector, reviewPopupSelector, reviewLeaveIntentInfo } from "../../../ReviewPage/redux/selector";
import { pushCtaOmniEvents } from "../../../../../shared/config/omni";
import { CTA_TYPE } from "../../../../../shared/utils/omni-utils"
import { LEAD_GEN_FORM } from "../../../../../shared/utils/util-constants";
import { submitQuerydetails } from "../../redux/thunks";
import { HelpForm } from "@gommt-cabs/ui-lib"
import { listingAssistedFlowInfo, listingLeaveIntentInfo, popupSelector, srpCommonDataSelector } from "../../../SearchPage/redux/selector";
import { commonSelector } from "../../redux/selector";

const TripAssistant = ({pageName = "Review", showIcon = false, showLeaveIntent = false, coupon = null }) => {
  const assistedFlowInfo = pageName === "Review" ? useSelector(reviewAssistedFlowInfo) : useSelector(listingAssistedFlowInfo); 
  const leaveIntentInfo  = pageName === "Review" ? useSelector(reviewLeaveIntentInfo) : useSelector(listingLeaveIntentInfo);
  const showTripAssistant = pageName === "Seo" ? showIcon : !!assistedFlowInfo;
  const showLeaveIntentForm = pageName === "Seo" ? showLeaveIntent : !!leaveIntentInfo;
  const travellerDetails = useSelector(travellerDetailsSelector);
  const showPopup = pageName === "Review" ? useSelector(reviewPopupSelector) : useSelector(popupSelector);
  const data = pageName === "Review" ? useSelector(reviewResultsSelector) : pageName === "Listing" ? useSelector(srpCommonDataSelector) : useSelector(commonSelector);
  const [formState, setFormState] = useState({
    isSubmitted: false,
    hasError: false,
  });

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const onFormSubmit = (phoneNumber:string) => {
    try {
      const reqBody = {
        destination: data?.destination_city?.toUpperCase() || "",
        email: travellerDetails?.email || "",
        mobile: phoneNumber || "",
        name: travellerDetails?.first_name || "",
        passengers: 1,
        source: data?.source_city?.toUpperCase() || "",
        travel_date:formatDate(data?.departure_time) || "",
        page: pageName,
        flavour:"cars_dweb"
      }
      const res = submitQuerydetails(reqBody);
      res
        .then((result) => {
          const isError = result?.error ? true : false;
          if (!isError) {
            setFormState({
              isSubmitted: true,
              hasError: false,
            });
          } else {
            setFormState({
              isSubmitted: true,
              hasError: true,
            });
          }
        })
        .catch(() => {
          console.log('Error submitting trip assistant query');
        });
    } catch (err) {
      console.log('Error submitting trip assistant form');
    }
  };

  const trackEvent = (eventName: string) => {
    setTimeout(() => {
      pushCtaOmniEvents(eventName, CTA_TYPE.HYPER_LINK, LEAD_GEN_FORM, window.location.href);
    }, 1000)
  };

  return (
    <HelpForm 
      trackEvent={trackEvent}
      onSubmit={onFormSubmit}
      formState={formState}
      setFormState={setFormState}
      pageName={pageName}
      orgId="GI"
      autoOpenDelay={assistedFlowInfo?.auto_form_open_delay ||  60000}
      hideForm={showPopup}
      showAssistantIcon={showTripAssistant}
      showLeaveIntentForm={showLeaveIntentForm}
      couponInfo={coupon}
      phoneNumber={travellerDetails?.phone_number}
      customerCareNumber={data?.contact_number}
    />
  );
};

export default TripAssistant;